export default "__VITE_ASSET__DBqMsj2O__"